<template>
  <patient-profile-find
    title="Create Quick Entry"
  ></patient-profile-find>
</template>

<script>
import PatientProfileFind from '@/components/patients/Find.vue'

export default {
  components: {
    PatientProfileFind,
  },
}
</script>
